/**
 * Prices in this system are Indian rupees — several screens were rendering a
 * bare number or a dollar glyph. Format them consistently.
 */
export const RUPEE = "₹";

export const formatMoney = (value) => {
  if (value === null || value === undefined || value === "") return "—";

  const n = Number(value);
  if (Number.isNaN(n)) return `${RUPEE}${value}`;

  return `${RUPEE}${n.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  })}`;
};

export default formatMoney;
